import React from 'react';
import { TableStates } from 'types';
import {
  Header,
  StatusCaption,
  StatusSeparator,
  StatusValue,
  Time,
  TimeUnits,
  TimeValue,
  Wrapper,
} from './styles';

export interface IProps {
  status: TableStates;
  timeValue?: number;
  statusText: string;
  className?: string;
  additionalText?: string;
}

export const StatusInfo = ({
  timeValue,
  status,
  statusText,
  className,
  additionalText,
}: IProps) => (
  <Wrapper className={className}>
    <Header>
      <StatusCaption>Status</StatusCaption>
      <StatusValue>{statusText}</StatusValue>
    </Header>
    <StatusSeparator />
    <Time status={status}>
      {additionalText && <TimeValue>{additionalText}</TimeValue>}
      {timeValue !== undefined && (
        <>
          <TimeValue>{timeValue}</TimeValue>
          <TimeUnits>sec</TimeUnits>
        </>
      )}
    </Time>
  </Wrapper>
);
